/**
 * Helpers de fecha-hora del reporte del controlador PTS2.
 *
 * El panel anterior usaba un `daterangepicker` con hora; aquí se usan dos
 * campos `datetime-local` (el formato que ve el usuario lo decide el navegador).
 */

/** Valor de `datetime-local` para una fecha concreta (minutos). */
export function aLocal(fecha: Date): string {
  const dosDigitos = (valor: number) => String(valor).padStart(2, '0');

  return `${fecha.getFullYear()}-${dosDigitos(fecha.getMonth() + 1)}-${dosDigitos(fecha.getDate())}T${dosDigitos(fecha.getHours())}:${dosDigitos(fecha.getMinutes())}`;
}

/** Convierte el valor de `datetime-local` al formato que espera la API. */
export function aApi(valor: string): string {
  if (!valor) return '';

  return valor.length === 16 ? `${valor.replace('T', ' ')}:00` : valor.replace('T', ' ');
}
